<template>
	<div
		class="bank-ticket-modal"
		:class="{'bank-ticket-modal--closed': closed}"
		role="dialog"
		aria-modal="true"
		:aria-hidden="closed ? 'true' : 'false'"
		@click.self="close"
	>
		<section class="bank-ticket-modal__content">
			<header class="bank-ticket-modal__header">
				<h2>{{title}}</h2>
				<button type="button" aria-label="Close" @click="close">&times;</button>
			</header>
			<div class="bank-ticket-modal__body">
				<p>{{message}}</p>
				<a v-if="bankTicketUrl" class="book-here" :href="bankTicketUrl" target="_blank">VISUALIZAR BOLETO</a>
			</div>
		</section>
  </div>
</template>

<script>
import { translate } from '../../assets/translations';
export default {
	data(){
		return{
			closed: true,
			title: '',
			message: '',
      bankTicketUrl: null,
		};
	},
  methods:{
    open(success, bankTicketUrl){
			this.bankTicketUrl = bankTicketUrl || null;
			this.buildResponse(success);
			this.closed = false;
    },
    close(){
      this.closed = true;
    },
		buildResponse(success){
			if(success){
        let message = translate(this.$store.state.language).conclusionBankTicketModal;
				this.title= message.title;
				this.message= message.text;
			}else{
				this.title="Reserva não efetuada.";
				this.message="Houve um problema na conclusão da reserva, tente novamente mais tarde.";
			}
		}
  }
}
</script>
<style scoped lang="scss">
.bank-ticket-modal--closed {
  visibility: hidden;
  opacity: 0;
  pointer-events: none;
}

.bank-ticket-modal {
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  z-index: 2000;
  inset: 0;
  padding: 9px;
  overflow-y: auto;
  background: rgba(0, 0, 0, .55);
  opacity: 1;
  transition: visibility .2s, opacity .2s linear;
}

.bank-ticket-modal__content {
  width: 100%;
  max-width: 560px;
  overflow: hidden;
  border-radius: 13px;
  background: #ffffff;
  box-shadow: 0 18px 45px rgba(0, 0, 0, .25);
}

.bank-ticket-modal__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 53px;
  padding: 0 11px 0 20px;
  background: #67adc6;
  color: #ffffff;
}

.bank-ticket-modal__header h2 {
  margin: 0;
  font-size: 16px;
  font-weight: 700;
  line-height: 20px;
}

.bank-ticket-modal__header button {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 34px;
  padding: 0;
  border: 0;
  background: transparent;
  color: #ffffff;
  font-size: 26px;
  font-weight: 700;
  line-height: 1;
  cursor: pointer;
}

.bank-ticket-modal__header button:focus-visible {
  outline: 2px solid #ffffff;
  outline-offset: -4px;
}

.bank-ticket-modal__body {
  box-sizing: border-box;
  min-height: 97px;
  padding: 24px;
  color: #4c4b4b;
}

.bank-ticket-modal__body p {
  margin: 0;
  line-height: 1.5;
}

.book-here {
  display: flex;
  align-items: center;
  justify-content: center;
  width: fit-content;
  min-height: 40px;
  box-sizing: border-box;
  margin: 20px 0 0;
  padding: 8px 28px;
  border-radius: 10px;
  background: #ff9600;
  color: #ffffff;
  font-size: 14px;
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/components/shared/ConclusionBankTicketModal.vue